import { FormikProvider, useFormik, Form, ErrorMessage, FieldArray, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Table, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { BiTrash } from "react-icons/bi";
import { VscDiffAdded } from "react-icons/vsc";

export default function ScrutinyReportForNewAc({ collCode }) {

    const defaultCollegeId = collCode;
    const handleNumericChange = (event) => {
        const { name, value } = event.target;
        formik.setFieldValue(name, value.replace(/[^0-9]/g, ""));
    };

    const [apiValues, setApiValues] = useState({});
    const [corpusFundInstall, setcorpusFundInstall] = useState([]);
    const [getUgCourses, setUgCourse] = useState([]);
    const [selectedFinalStatus, setSelectedFinalStatus] = useState("");
    const [deficiencies, setDeficiencies] = useState([
        { id: 1, deficiency: "" }
    ]);

    const focusFirstErrorField = (errors) => {
        const firstErrorField = Object.keys(errors)[0];

        if (!firstErrorField) {
            return;
        }

        const element = document.querySelector(
            `input[name="${firstErrorField}"], select[name="${firstErrorField}"], textarea[name="${firstErrorField}"]`
        );

        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
            element.focus();
        }
    };

    const markAllFieldsTouched = (values) => {
        formik.setTouched(
            Object.keys(values).reduce((accumulator, key) => {
                accumulator[key] = true;
                return accumulator;
            }, {})
        );
    };


    // Validation Schema - Only boolean fields are required, remarks are optional
    const validationSchema = Yup.object().shape({
        isFeePaid: Yup.string().required("Required"),
        isSocietyRegistered: Yup.string().required("Required"),
        isByeLawsEnclosed: Yup.string().required("Required"),
        locationType: Yup.string().required("Required"),
        isIdentifiedLocation: Yup.string().required("Required"),
        isOtherEducationalInstitution: Yup.string().required("Required"),
        isTemporaryPremisesBeyondTenYears: Yup.string().required("Required"),
        isCriminalBehavior: Yup.string().required("Required"),
        isUgcRecognition: Yup.string().required("Required"),
        isPendingDuesOrComplaints: Yup.string().required("Required"),
        isEligibleForNewCollege: Yup.string().required("Required"),
        isOwnLand: Yup.string().required("Required"),
        isLandDeed: Yup.string().required("Required"),
        isLandInSocietyName: Yup.string().required("Required"),
        isLandInSameMandal: Yup.string().required("Required"),
        isLandSketchPlan: Yup.string().required("Required"),
        isLandScheduleTally: Yup.string().required("Required"),
        isBuildingDeed: Yup.string().required("Required"),
        isBuildingPlan: Yup.string().required("Required"),
        isApprovedPlanProduced: Yup.string().required("Required"),
        isBuildingScheduleTally: Yup.string().required("Required"),
        isBuildingCarpetAreaAsPerNorms: Yup.string().required("Required"),
        isConstructionPermissionOrder: Yup.string().required("Required"),
        isBuildingLocationAsPerNorms: Yup.string().required("Required"),
        isBuildingCompletionCertificate: Yup.string().required("Required"),
        isSanitaryCertificate: Yup.string().required("Required"),
        isGeotaggedPhotos: Yup.string().required("Required"),
        isOtherInstitutionInSameBuilding: Yup.string().required("Required"),
        isAnnexureOneBuildingDetails: Yup.string().required("Required"),
        isParkingInSamePremises: Yup.string().required("Required"),
        isParkingBuiltUpArea: Yup.string().required("Required"),
        isParkingWithinHundredMeters: Yup.string().required("Required"),
        isPlaygroundInSamePremises: Yup.string().required("Required"),
        isAlternativePlaygroundArrangement: Yup.string().required("Required"),
        isPlaygroundMouProduced: Yup.string().required("Required"),
        isLatestFireSafetyCertificate: Yup.string().required("Required"),
        financialResourceAmountRequired: Yup.string().required("Required"),
        isFinancialResourcesSufficient: Yup.string().required("Required"),
        isFinancialResourcePurposeMentioned: Yup.string().required("Required"),
        newProgrammeApprovalFee: Yup.string().required("Required"),
        isDetailedProjectReportUploaded: Yup.string().required("Required"),
        isDevelopmentPlanUploaded: Yup.string().required("Required"),
        isArchitecturalMasterPlanUploaded: Yup.string().required("Required"),
        isAcademicAdministrativeGovernanceUploaded: Yup.string().required("Required"),
        isSourcesOfFinancingUploaded: Yup.string().required("Required"),
        isFacultyPoliciesUploaded: Yup.string().required("Required"),
        finalRemarks: Yup.string().required("Required"),
        finalStatus: Yup.string().required("Required"),
    });

    const formik = useFormik({
        initialValues: {
            // Registration and Processing Fee
            isFeePaid: "",
            regFeeRemarks: "",


            // 1.2 Sponsoring Society Details
            isSocietyRegistered: "",
            societyRegisteredRemarks: "",
            isByeLawsEnclosed: "",
            byeLawsRemarks: "",
            locationType: "",
            locationRemarks: "",
            isIdentifiedLocation: "",
            identifiedLocationRemarks: "",
            isOtherEducationalInstitution: "",
            otherInstitutionRemarks: "",
            isTemporaryPremisesBeyondTenYears: "",
            temporaryPremisesBeyondTenYearsRemarks: "",
            isCriminalBehavior: "",
            criminalBehaviorRemarks: "",
            isUgcRecognition: "",
            ugcRecognitionRemarks: "",
            isPendingDuesOrComplaints: "",
            pendingDuesOrComplaintsRemarks: "",
            isEligibleForNewCollege: "",
            eligibleForNewCollegeRemarks: "",


            // 2. Details of the Own Land
            isOwnLand: "",
            ownLandRemarks: "",
            isLandDeed: "",
            landDeedRemarks: "",
            isLandInSocietyName: "",
            landInSocietyNameRemarks: "",
            isLandInSameMandal: "",
            landInSameMandalRemarks: "",
            isLandSketchPlan: "",
            landSketchPlanRemarks: "",
            isLandScheduleTally: "",
            landScheduleTallyRemarks: "",


            // 3. Building Accommodation
            isBuildingDeed: "",
            buildingDeedRemarks: "",
            isBuildingPlan: "",
            buildingPlanRemarks: "",
            competentAuthorityDesignation: "",
            competentAuthorityDesignationRemarks: "",
            isApprovedPlanProduced: "",
            approvedPlanProducedRemarks: "",
            isBuildingScheduleTally: "",
            buildingScheduleTallyRemarks: "",
            isBuildingCarpetAreaAsPerNorms: "",
            buildingCarpetAreaAsPerNormsRemarks: "",
            isConstructionPermissionOrder: "",
            constructionPermissionOrderRemarks: "",
            isBuildingLocationAsPerNorms: "",
            buildingLocationAsPerNormsRemarks: "",
            isBuildingCompletionCertificate: "",
            buildingCompletionCertificateRemarks: "",
            isSanitaryCertificate: "",
            sanitaryRemarks: "",
            isGeotaggedPhotos: "",
            geoPhotosRemarks: "",
            isOtherInstitutionInSameBuilding: "",
            otherInstitutionInSameBuildingRemarks: "",
            isAnnexureOneBuildingDetails: "",
            annexureOneBuildingDetailsRemarks: "",

            // 3.14 Parking Area
            isParkingInSamePremises: "",
            parkingInSamePremisesRemarks: "",
            isParkingBuiltUpArea: "",
            parkingBuiltUpAreaRemarks: "",
            isParkingWithinHundredMeters: "",
            parkingWithinHundredMetersRemarks: "",


            // 3.15 Playground
            isPlaygroundInSamePremises: "",
            playgroundInSamePremisesRemarks: "",
            playgroundExtent: "",
            playgroundExtentRemarks: "",
            isAlternativePlaygroundArrangement: "",
            alternativePlaygroundArrangementRemarks: "",
            isPlaygroundMouProduced: "",
            playgroundMouProducedRemarks: "",


            // 3.16 Fire Safety
            isLatestFireSafetyCertificate: "",
            latestFireSafetyCertificateRemarks: "",


            // 4. Details of Proposed UG Programmes
            baCount: "",
            bcomCount: "",
            bscCount: "",
            bbaCount: "",
            bcaCount: "",
            bvocCount: "",


            // 5. Financial Resource
            financialResourceAmountRequired: "",
            isFinancialResourcesSufficient: "",
            financialResourcesSufficientRemarks: "",
            financialResourceDeficit: "",
            isFinancialResourcePurposeMentioned: "",
            financialResourcePurposeMentionedRemarks: "",


            // 6. Corpus Fund for Proposed College
            corpusFundProgramme1: "",
            corpusFundAmount1: "",
            corpusFundPeriod1: "",
            corpusFundFdrNo1: "",
            corpusFundDate1: "",
            corpusFundBankName1: "",
            corpusFundMaturityDate1: "",
            corpusFundRenewalDate1: "",
            corpusFundProgramme2: "",
            corpusFundAmount2: "",
            corpusFundPeriod2: "",
            corpusFundFdrNo2: "",
            corpusFundDate2: "",
            corpusFundBankName2: "",
            corpusFundMaturityDate2: "",
            corpusFundRenewalDate2: "",


            // 7. New Programme Approval Fee
            newProgrammeApprovalFee: "",


            // 8. DPR and Other Relevant Documents
            isDetailedProjectReportUploaded: "",
            detailedProjectReportUploadedRemarks: "",
            isDevelopmentPlanUploaded: "",
            developmentPlanUploadedRemarks: "",
            isArchitecturalMasterPlanUploaded: "",
            architecturalMasterPlanUploadedRemarks: "",
            isAcademicAdministrativeGovernanceUploaded: "",
            academicAdministrativeGovernanceUploadedRemarks: "",
            isSourcesOfFinancingUploaded: "",
            sourcesOfFinancingUploadedRemarks: "",
            isFacultyPoliciesUploaded: "",
            facultyPoliciesUploadedRemarks: "",
            finalRemarks: "",
            finalStatus: "",
            deficiencies: [{ remarks: "" }],
        },
        enableReinitialize: false,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values) => {
            const errors = await formik.validateForm();

            if (Object.keys(errors).length > 0) {
                markAllFieldsTouched(values);
                focusFirstErrorField(errors);
                formik.setSubmitting(false);
                return;
            }

            submitInspClosureInst(values, "submit");
            formik.setSubmitting(false);
        }
    });

    const buildScrutinyPayload = (values) => {
        return {
            collCode: defaultCollegeId,
            isFeePaid: values.isFeePaid === "Yes",
            regFeeRemarks: values.regFeeRemarks || "",
            isSocietyRegistered: values.isSocietyRegistered === "Yes",
            societyRegisteredRemarks: values.societyRegisteredRemarks || "",
            isByeLawsEnclosed: values.isByeLawsEnclosed === "Yes",
            byeLawsRemarks: values.byeLawsRemarks || "",
            locationType: values.locationType || "",
            locationRemarks: values.locationRemarks || "",
            isIdentifiedLocation: values.isIdentifiedLocation === "Yes",
            identifiedLocationRemarks: values.identifiedLocationRemarks || "",
            isOtherEducationalInstitution: values.isOtherEducationalInstitution === "Yes",
            otherInstitutionRemarks: values.otherInstitutionRemarks || "",
            isTemporaryPremisesBeyondTenYears: values.isTemporaryPremisesBeyondTenYears === "Yes",
            temporaryPremisesBeyondTenYearsRemarks: values.temporaryPremisesBeyondTenYearsRemarks || "",
            isCriminalBehavior: values.isCriminalBehavior === "Yes",
            criminalBehaviorRemarks: values.criminalBehaviorRemarks || "",
            isUgcRecognition: values.isUgcRecognition === "Yes",
            ugcRecognitionRemarks: values.ugcRecognitionRemarks || "",
            isPendingDuesOrComplaints: values.isPendingDuesOrComplaints === "Yes",
            pendingDuesOrComplaintsRemarks: values.pendingDuesOrComplaintsRemarks || "",
            isEligibleForNewCollege: values.isEligibleForNewCollege === "Yes",
            eligibleForNewCollegeRemarks: values.eligibleForNewCollegeRemarks || "",
            isOwnLand: values.isOwnLand === "Yes",
            ownLandRemarks: values.ownLandRemarks || "",
            isLandDeed: values.isLandDeed === "Yes",
            landDeedRemarks: values.landDeedRemarks || "",
            isLandInSocietyName: values.isLandInSocietyName === "Yes",
            landInSocietyNameRemarks: values.landInSocietyNameRemarks || "",
            isLandInSameMandal: values.isLandInSameMandal === "Yes",
            landInSameMandalRemarks: values.landInSameMandalRemarks || "",
            isLandSketchPlan: values.isLandSketchPlan === "Yes",
            landSketchPlanRemarks: values.landSketchPlanRemarks || "",
            isLandScheduleTally: values.isLandScheduleTally === "Yes",
            landScheduleTallyRemarks: values.landScheduleTallyRemarks || "",
            isBuildingDeed: values.isBuildingDeed === "Yes",
            buildingDeedRemarks: values.buildingDeedRemarks || "",
            isBuildingPlan: values.isBuildingPlan === "Yes",
            buildingPlanRemarks: values.buildingPlanRemarks || "",
            competentAuthorityDesignationRemarks: values.competentAuthorityDesignationRemarks || "",
            isApprovedPlanProduced: values.isApprovedPlanProduced === "Yes",
            approvedPlanProducedRemarks: values.approvedPlanProducedRemarks || "",
            isBuildingScheduleTally: values.isBuildingScheduleTally === "Yes",
            buildingScheduleTallyRemarks: values.buildingScheduleTallyRemarks || "",
            isBuildingCarpetAreaAsPerNorms: values.isBuildingCarpetAreaAsPerNorms === "Yes",
            buildingCarpetAreaAsPerNormsRemarks: values.buildingCarpetAreaAsPerNormsRemarks || "",
            isConstructionPermissionOrder: values.isConstructionPermissionOrder === "Yes",
            constructionPermissionOrderRemarks: values.constructionPermissionOrderRemarks || "",
            isBuildingLocationAsPerNorms: values.isBuildingLocationAsPerNorms === "Yes",
            buildingLocationAsPerNormsRemarks: values.buildingLocationAsPerNormsRemarks || "",
            isBuildingCompletionCertificate: values.isBuildingCompletionCertificate === "Yes",
            buildingCompletionCertificateRemarks: values.buildingCompletionCertificateRemarks || "",
            isSanitaryCertificate: values.isSanitaryCertificate === "Yes",
            sanitaryRemarks: values.sanitaryRemarks || "",
            isGeotaggedPhotos: values.isGeotaggedPhotos === "Yes",
            geoPhotosRemarks: values.geoPhotosRemarks || "",
            isOtherInstitutionInSameBuilding: values.isOtherInstitutionInSameBuilding === "Yes",
            otherInstitutionInSameBuildingRemarks: values.otherInstitutionInSameBuildingRemarks || "",
            isAnnexureOneBuildingDetails: values.isAnnexureOneBuildingDetails === "Yes",
            annexureOneBuildingDetailsRemarks: values.annexureOneBuildingDetailsRemarks || "",
            isParkingInSamePremises: values.isParkingInSamePremises === "Yes",
            parkingInSamePremisesRemarks: values.parkingInSamePremisesRemarks || "",
            isParkingBuiltUpArea: values.isParkingBuiltUpArea === "Yes",
            parkingBuiltUpAreaRemarks: values.parkingBuiltUpAreaRemarks || "",
            isParkingWithinHundredMeters: values.isParkingWithinHundredMeters === "Yes",
            parkingWithinHundredMetersRemarks: values.parkingWithinHundredMetersRemarks || "",
            isPlaygroundInSamePremises: values.isPlaygroundInSamePremises === "Yes",
            playgroundInSamePremisesRemarks: values.playgroundInSamePremisesRemarks || "",
            playgroundExtentRemarks: values.playgroundExtentRemarks || "",
            isAlternativePlaygroundArrangement: values.isAlternativePlaygroundArrangement === "Yes",
            alternativePlaygroundArrangementRemarks: values.alternativePlaygroundArrangementRemarks || "",
            isPlaygroundMouProduced: values.isPlaygroundMouProduced === "Yes",
            playgroundMouProducedRemarks: values.playgroundMouProducedRemarks || "",
            isLatestFireSafetyCertificate: values.isLatestFireSafetyCertificate === "Yes",
            latestFireSafetyCertificateRemarks: values.latestFireSafetyCertificateRemarks || "",
            financialResourceAmountRequired: values.financialResourceAmountRequired || "0",
            isFinancialResourcesSufficient: values.isFinancialResourcesSufficient === "Yes",
            financialResourcesSufficientRemarks: values.financialResourcesSufficientRemarks || "",
            financialResourceDeficit: values.financialResourceDeficit || "0",
            isFinancialResourcePurposeMentioned: values.isFinancialResourcePurposeMentioned === "Yes",
            financialResourcePurposeMentionedRemarks: values.financialResourcePurposeMentionedRemarks || "",
            newProgrammeApprovalFee: values.newProgrammeApprovalFee || "0",
            isDetailedProjectReportUploaded: values.isDetailedProjectReportUploaded === "Yes",
            detailedProjectReportUploadedRemarks: values.detailedProjectReportUploadedRemarks || "",
            isDevelopmentPlanUploaded: values.isDevelopmentPlanUploaded === "Yes",
            developmentPlanUploadedRemarks: values.developmentPlanUploadedRemarks || "",
            isArchitecturalMasterPlanUploaded: values.isArchitecturalMasterPlanUploaded === "Yes",
            architecturalMasterPlanUploadedRemarks: values.architecturalMasterPlanUploadedRemarks || "",
            isAcademicAdministrativeGovernanceUploaded: values.isAcademicAdministrativeGovernanceUploaded === "Yes",
            academicAdministrativeGovernanceUploadedRemarks: values.academicAdministrativeGovernanceUploadedRemarks || "",
            isSourcesOfFinancingUploaded: values.isSourcesOfFinancingUploaded === "Yes",
            sourcesOfFinancingUploadedRemarks: values.sourcesOfFinancingUploadedRemarks || "",
            isFacultyPoliciesUploaded: values.isFacultyPoliciesUploaded === "Yes",
            facultyPoliciesUploadedRemarks: values.facultyPoliciesUploadedRemarks || "",
            finalRemarks: values.finalRemarks || "",
            finalStatus: values.finalStatus || "",
            // finalStatusPayLoad: values.finalStatus ? [
            //     {
            //         finalStatus: values.finalStatus
            //     }
            // ] : [],
            finalStatusPayLoad: values.deficiencies && values.deficiencies.length > 0 ? values.deficiencies.map(d => ({
                finalStatus: d.remarks || ""
            })) : []
        };
    };
    console.log("formik values", buildScrutinyPayload(formik.values))
    function submitInspClosureInst(values, mode = "submit") {
        if (!defaultCollegeId) {
            failureAlert("Login Data not found,Please login again.");
            return;
        }

        if (mode === "save") {
            showSubmitConfirmation(values, mode);
            return;
        }

        showSubmitConfirmation(values, mode);
    }

    const showSubmitConfirmation = (values, mode) => {
        Swal.fire({
            title: "Are you sure?",
            text: mode === "save"
                ? "Do you want to save the draft?"
                : "Do you want to submit?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: mode === "save" ? "Yes, Save Draft" : "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (!result.isConfirmed) {
                return;
            }

            if (mode === "save") {
                const draftPayload = {
                    values,
                    deficiencies,
                    savedAt: new Date().toISOString(),
                    collCode: defaultCollegeId,
                };

                sessionStorage.setItem("scrutinyReportForNewAcDraft", JSON.stringify(draftPayload));
                successAlert2("Draft saved locally.");
                return;
            }

            try {
                const payload = buildScrutinyPayload(values);
                const response = await CommonAxiosPost(
                    `${config.url.FAC_URL}scrutinyDataForNewAc`,
                    payload
                );

                const responseData = response?.data || {};
                const statusCode = responseData?.scode;
                const responseMessage = responseData?.sdesc || "Failed to submit scrutiny report. Please try again.";

                if (statusCode === "01" || responseData?.status === true) {
                    successAlert2(responseMessage);
                    return;
                }

                failureAlert(responseMessage);
            } catch (error) {
                failureAlert("An error occurred while submitting the form: " + error.message);
            }
        });
    }

    const handleSubmitClick = async () => {
        const errors = await formik.validateForm();

        if (Object.keys(errors).length > 0) {
            markAllFieldsTouched(formik.values);
            focusFirstErrorField(errors);
            return;
        }

        submitInspClosureInst(formik.values, "submit");
    };

    const handleSave = async () => {
        const finalStatusSelected = formik.values.finalStatus && formik.values.finalStatus.trim() !== "";

        if (finalStatusSelected) {
            const errors = await formik.validateForm();

            if (Object.keys(errors).length > 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Cannot Save with Final Status",
                    html: `You have selected a <strong>Final Status</strong> but some required fields are missing.<br/><br/>To save as a <strong>draft</strong>, please clear the Final Status selection.<br/>Or fill all required fields before saving with Final Status.`,
                    confirmButtonColor: "#d33",
                    confirmButtonText: "OK"
                });
                return;
            }
        }

        submitInspClosureInst(formik.values, "save");
    };

    const handleFinalStatusChange = (event) => {
        const { value } = event.target;
        setSelectedFinalStatus(value);
        formik.setFieldValue("finalStatus", value);
    };

    const [getScrtinyDtlsforclg, setScrtinyDtlsforclg] = useState({});
    function fetchScrutinyForClgApplication() {
        if (!collCode) {
            failureAlert("College code not found. Please login again.");
            return;
        }
        let url = `${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${collCode}`;
        CommonAxiosGet(url)
            .then((response) => {
                const responseData = response?.data?.data;
                setScrtinyDtlsforclg(responseData);
                // Extract BasicDetails and ScrutinyFinalStatus
                const basicDetails = responseData.BasicDetails?.[0] || {};
                const scrutinyFinalStatus = responseData.ScrutinyFinalStatus || [];

                // Helper function to convert boolean to Yes/No
                const boolToYesNo = (value) => {
                    if (value === true || value === "true" || value === "Yes") return "Yes";
                    if (value === false || value === "false" || value === "No") return "No";
                    return "";
                };

                // Map all form values from API response
                const mappedValues = {
                    isFeePaid: boolToYesNo(basicDetails.isfee_paid),
                    regFeeRemarks: basicDetails.regfee_remarks || "",
                    isSocietyRegistered: boolToYesNo(basicDetails.issociety_registered),
                    societyRegisteredRemarks: basicDetails.society_registered_remarks || "",
                    isByeLawsEnclosed: boolToYesNo(basicDetails.isbye_laws_enclosed),
                    byeLawsRemarks: basicDetails.bye_laws_remarks || "",
                    locationType: basicDetails.location_type || "",
                    locationRemarks: basicDetails.location_remarks || "",
                    isIdentifiedLocation: boolToYesNo(basicDetails.isidentified_location),
                    identifiedLocationRemarks: basicDetails.identified_location_remarks || "",
                    isOtherEducationalInstitution: boolToYesNo(basicDetails.isother_educational_institution),
                    otherInstitutionRemarks: basicDetails.other_institution_remarks || "",
                    isTemporaryPremisesBeyondTenYears: boolToYesNo(basicDetails.istemporary_premises_beyond_ten_years),
                    temporaryPremisesBeyondTenYearsRemarks: basicDetails.temporary_premises_beyond_ten_years_remarks || "",
                    isCriminalBehavior: boolToYesNo(basicDetails.iscriminal_behavior),
                    criminalBehaviorRemarks: basicDetails.criminal_behavior_remarks || "",
                    isUgcRecognition: boolToYesNo(basicDetails.isugc_recognition),
                    ugcRecognitionRemarks: basicDetails.ugc_recognition_remarks || "",
                    isPendingDuesOrComplaints: boolToYesNo(basicDetails.ispending_dues_or_complaints),
                    pendingDuesOrComplaintsRemarks: basicDetails.pending_dues_or_complaints_remarks || "",
                    isEligibleForNewCollege: boolToYesNo(basicDetails.iseligible_for_new_college),
                    eligibleForNewCollegeRemarks: basicDetails.eligible_for_new_college_remarks || "",
                    isOwnLand: boolToYesNo(basicDetails.isown_land),
                    ownLandRemarks: basicDetails.own_land_remarks || "",
                    isLandDeed: boolToYesNo(basicDetails.island_deed),
                    landDeedRemarks: basicDetails.land_deed_remarks || "",
                    isLandInSocietyName: boolToYesNo(basicDetails.island_in_society_name),
                    landInSocietyNameRemarks: basicDetails.land_in_society_name_remarks || "",
                    isLandInSameMandal: boolToYesNo(basicDetails.island_in_same_mandal),
                    landInSameMandalRemarks: basicDetails.land_in_same_mandal_remarks || "",
                    isLandSketchPlan: boolToYesNo(basicDetails.island_sketch_plan),
                    landSketchPlanRemarks: basicDetails.land_sketch_plan_remarks || "",
                    isLandScheduleTally: boolToYesNo(basicDetails.island_schedule_tally),
                    landScheduleTallyRemarks: basicDetails.land_schedule_tally_remarks || "",
                    isBuildingDeed: boolToYesNo(basicDetails.isbuilding_deed),
                    buildingDeedRemarks: basicDetails.building_deed_remarks || "",
                    isBuildingPlan: boolToYesNo(basicDetails.isbuilding_plan),
                    buildingPlanRemarks: basicDetails.building_plan_remarks || "",
                    competentAuthorityDesignationRemarks: basicDetails.competent_authority_designation_remarks || "",
                    isApprovedPlanProduced: boolToYesNo(basicDetails.isapproved_plan_produced),
                    approvedPlanProducedRemarks: basicDetails.approved_plan_produced_remarks || "",
                    isBuildingScheduleTally: boolToYesNo(basicDetails.isbuilding_schedule_tally),
                    buildingScheduleTallyRemarks: basicDetails.building_schedule_tally_remarks || "",
                    isBuildingCarpetAreaAsPerNorms: boolToYesNo(basicDetails.isbuilding_carpet_area_as_per_norms),
                    buildingCarpetAreaAsPerNormsRemarks: basicDetails.building_carpet_area_as_per_norms_remarks || "",
                    isConstructionPermissionOrder: boolToYesNo(basicDetails.isconstruction_permission_order),
                    constructionPermissionOrderRemarks: basicDetails.construction_permission_order_remarks || "",
                    isBuildingLocationAsPerNorms: boolToYesNo(basicDetails.isbuilding_location_as_per_norms),
                    buildingLocationAsPerNormsRemarks: basicDetails.building_location_as_per_norms_remarks || "",
                    isBuildingCompletionCertificate: boolToYesNo(basicDetails.isbuilding_completion_certificate),
                    buildingCompletionCertificateRemarks: basicDetails.building_completion_certificate_remarks || "",
                    isSanitaryCertificate: boolToYesNo(basicDetails.issanitary_certificate),
                    sanitaryRemarks: basicDetails.sanitary_remarks || "",
                    isGeotaggedPhotos: boolToYesNo(basicDetails.isgeotagged_photos),
                    geoPhotosRemarks: basicDetails.geo_photos_remarks || "",
                    isOtherInstitutionInSameBuilding: boolToYesNo(basicDetails.isother_institution_in_same_building),
                    otherInstitutionInSameBuildingRemarks: basicDetails.other_institution_in_same_building_remarks || "",
                    isAnnexureOneBuildingDetails: boolToYesNo(basicDetails.isannexure_one_building_details),
                    annexureOneBuildingDetailsRemarks: basicDetails.annexure_one_building_details_remarks || "",
                    isParkingInSamePremises: boolToYesNo(basicDetails.isparking_in_same_premises),
                    parkingInSamePremisesRemarks: basicDetails.parking_in_same_premises_remarks || "",
                    isParkingBuiltUpArea: boolToYesNo(basicDetails.isparking_built_up_area),
                    parkingBuiltUpAreaRemarks: basicDetails.parking_built_up_area_remarks || "",
                    isParkingWithinHundredMeters: boolToYesNo(basicDetails.isparking_within_hundred_meters),
                    parkingWithinHundredMetersRemarks: basicDetails.parking_within_hundred_meters_remarks || "",
                    isPlaygroundInSamePremises: boolToYesNo(basicDetails.isplayground_in_same_premises),
                    playgroundInSamePremisesRemarks: basicDetails.playground_in_same_premises_remarks || "",
                    playgroundExtent: basicDetails.playground_extent || "",
                    playgroundExtentRemarks: basicDetails.playground_extent_remarks || "",
                    isAlternativePlaygroundArrangement: boolToYesNo(basicDetails.isalternative_playground_arrangement),
                    alternativePlaygroundArrangementRemarks: basicDetails.alternative_playground_arrangement_remarks || "",
                    isPlaygroundMouProduced: boolToYesNo(basicDetails.isplayground_mou_produced),
                    playgroundMouProducedRemarks: basicDetails.playground_mou_produced_remarks || "",
                    isLatestFireSafetyCertificate: boolToYesNo(basicDetails.islatest_fire_safety_certificate),
                    latestFireSafetyCertificateRemarks: basicDetails.latest_fire_safety_certificate_remarks || "",
                    financialResourceAmountRequired: basicDetails.financial_resource_amount_required || "",
                    isFinancialResourcesSufficient: boolToYesNo(basicDetails.isfinancial_resources_sufficient),
                    financialResourcesSufficientRemarks: basicDetails.financial_resources_sufficient_remarks || "",
                    financialResourceDeficit: basicDetails.financial_resource_deficit || "",
                    isFinancialResourcePurposeMentioned: boolToYesNo(basicDetails.isfinancial_resource_purpose_mentioned),
                    financialResourcePurposeMentionedRemarks: basicDetails.financial_resource_purpose_mentioned_remarks || "",
                    newProgrammeApprovalFee: basicDetails.new_programme_approval_fee || "",
                    isDetailedProjectReportUploaded: boolToYesNo(basicDetails.isdetailed_project_report_uploaded),
                    detailedProjectReportUploadedRemarks: basicDetails.detailed_project_report_uploaded_remarks || "",
                    isDevelopmentPlanUploaded: boolToYesNo(basicDetails.isdevelopment_plan_uploaded),
                    developmentPlanUploadedRemarks: basicDetails.development_plan_uploaded_remarks || "",
                    isArchitecturalMasterPlanUploaded: boolToYesNo(basicDetails.isarchitectural_master_plan_uploaded),
                    architecturalMasterPlanUploadedRemarks: basicDetails.architectural_master_plan_uploaded_remarks || "",
                    isAcademicAdministrativeGovernanceUploaded: boolToYesNo(basicDetails.isacademic_administrative_governance_uploaded),
                    academicAdministrativeGovernanceUploadedRemarks: basicDetails.academic_administrative_governance_uploaded_remarks || "",
                    isSourcesOfFinancingUploaded: boolToYesNo(basicDetails.issources_of_financing_uploaded),
                    sourcesOfFinancingUploadedRemarks: basicDetails.sources_of_financing_uploaded_remarks || "",
                    isFacultyPoliciesUploaded: boolToYesNo(basicDetails.isfaculty_policies_uploaded),
                    facultyPoliciesUploadedRemarks: basicDetails.faculty_policies_uploaded_remarks || "",
                    finalRemarks: basicDetails.final_remarks || "",
                    finalStatus: basicDetails.final_status || "",
                    deficiencies: scrutinyFinalStatus.length > 0
                        ? scrutinyFinalStatus.map(item => ({ remarks: item.final_status || "" }))
                        : [{ remarks: "" }],
                };

                // Set formik values and selected status
                formik.setValues(mappedValues);
                setSelectedFinalStatus(basicDetails.final_status || "");

            })
            .catch((error) => {
                setScrtinyDtlsforclg({});
                console.error("Failed to fetch scrutiny report details", error);
            });
    }
    const scrutinyTableStyle = {
        tableLayout: "fixed"
    };

    const yesNoHeaderStyle = {
        width: "14%",
        paddingLeft: "2px",
        paddingRight: "2px"
    };

    const remarksHeaderStyle = {
        width: "26%"
    };

    const currentFinalStatus = (selectedFinalStatus || formik.values.finalStatus || "").trim();
    const showDeficienciesSection = currentFinalStatus === "DeficiencyIdentified";
    const showUgProgramsSection = getUgCourses.length > 0;
    const showCorpusFundSection = corpusFundInstall.length > 0;

    const getDisplayValue = (value) => value || "-";

    const formatDate = (value) => {
        if (!value) {
            return "-";
        }

        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return value;
        }

        return date.toLocaleDateString("en-GB");
    };

    const addDeficiencyRow = () => {
        const nextId = Math.max(...deficiencies.map((item) => item.id), 0) + 1;
        setDeficiencies([...deficiencies, { id: nextId, deficiency: "" }]);
    };

    const deleteDeficiencyRow = (id) => {
        if (deficiencies.length === 1) {
            failureAlert("At least one row must remain");
            return;
        }

        setDeficiencies(deficiencies.filter((item) => item.id !== id));
    };

    const updateDeficiency = (id, value) => {
        setDeficiencies(
            deficiencies.map(d => (d.id === id ? { ...d, deficiency: value } : d))
        );
    };

    // API 1: Fetch College Details for Table Display
    useEffect(() => {
        if (!defaultCollegeId) return;

        const fetchCollegeDetails = async () => {
            try {
                const response = await CommonAxiosGet(
                    `${config.url.FAC_URL}getCollegeDetailsById?collCode=${defaultCollegeId}`
                );
                const collegeData = response?.data || {};
                setApiValues(collegeData?.mainDetails?.[0] || {});

                // Set UG Courses/Programmes for table display
                if (collegeData.ugPrograms && Array.isArray(collegeData.ugPrograms)) {
                    setUgCourse(collegeData.ugPrograms);
                }

                // Set Corpus Fund Installations for table display
                if (collegeData.corpusFundDetails && Array.isArray(collegeData.corpusFundDetails)) {
                    setcorpusFundInstall(collegeData.corpusFundDetails);
                }
            } catch (error) {
                console.error("Failed to fetch college details", error);
            }
        };

        fetchCollegeDetails();
    }, [defaultCollegeId]);

    // API 2: Fetch Scrutiny Data and Populate Form Fields
    useEffect(() => {
        if (!defaultCollegeId) {
            failureAlert("College code not found. Please login again.");
            return;
        }

        const fetchScrutinyData = async () => {
            try {
                const response = await CommonAxiosGet(
                    `${config.url.FAC_URL}getScrutinyDataForNewAc?collCode=${defaultCollegeId}`
                );

                const responseData = response?.data || {};
                const basicDetails = responseData.BasicDetails?.[0] || {};
                const scrutinyFinalStatus = responseData.ScrutinyFinalStatus || [];

                // Boolean to Yes/No converter
                const boolToYesNo = (value) => {
                    if (value === true || value === "true") return "Yes";
                    if (value === false || value === "false") return "No";
                    return "";
                };

                // Map all form values from API response
                const mappedValues = {
                    isFeePaid: boolToYesNo(basicDetails.isfee_paid),
                    regFeeRemarks: basicDetails.regfee_remarks || "",
                    isSocietyRegistered: boolToYesNo(basicDetails.issociety_registered),
                    societyRegisteredRemarks: basicDetails.society_registered_remarks || "",
                    isByeLawsEnclosed: boolToYesNo(basicDetails.isbye_laws_enclosed),
                    byeLawsRemarks: basicDetails.bye_laws_remarks || "",
                    locationType: basicDetails.location_type || "",
                    locationRemarks: basicDetails.location_remarks || "",
                    isIdentifiedLocation: boolToYesNo(basicDetails.isidentified_location),
                    identifiedLocationRemarks: basicDetails.identified_location_remarks || "",
                    isOtherEducationalInstitution: boolToYesNo(basicDetails.isother_educational_institution),
                    otherInstitutionRemarks: basicDetails.other_institution_remarks || "",
                    isTemporaryPremisesBeyondTenYears: boolToYesNo(basicDetails.istemporary_premises_beyond_ten_years),
                    temporaryPremisesBeyondTenYearsRemarks: basicDetails.temporary_premises_beyond_ten_years_remarks || "",
                    isCriminalBehavior: boolToYesNo(basicDetails.iscriminal_behavior),
                    criminalBehaviorRemarks: basicDetails.criminal_behavior_remarks || "",
                    isUgcRecognition: boolToYesNo(basicDetails.isugc_recognition),
                    ugcRecognitionRemarks: basicDetails.ugc_recognition_remarks || "",
                    isPendingDuesOrComplaints: boolToYesNo(basicDetails.ispending_dues_or_complaints),
                    pendingDuesOrComplaintsRemarks: basicDetails.pending_dues_or_complaints_remarks || "",
                    isEligibleForNewCollege: boolToYesNo(basicDetails.iseligible_for_new_college),
                    eligibleForNewCollegeRemarks: basicDetails.eligible_for_new_college_remarks || "",
                    isOwnLand: boolToYesNo(basicDetails.isown_land),
                    ownLandRemarks: basicDetails.own_land_remarks || "",
                    isLandDeed: boolToYesNo(basicDetails.island_deed),
                    landDeedRemarks: basicDetails.land_deed_remarks || "",
                    isLandInSocietyName: boolToYesNo(basicDetails.island_in_society_name),
                    landInSocietyNameRemarks: basicDetails.land_in_society_name_remarks || "",
                    isLandInSameMandal: boolToYesNo(basicDetails.island_in_same_mandal),
                    landInSameMandalRemarks: basicDetails.land_in_same_mandal_remarks || "",
                    isLandSketchPlan: boolToYesNo(basicDetails.island_sketch_plan),
                    landSketchPlanRemarks: basicDetails.land_sketch_plan_remarks || "",
                    isLandScheduleTally: boolToYesNo(basicDetails.island_schedule_tally),
                    landScheduleTallyRemarks: basicDetails.land_schedule_tally_remarks || "",
                    isBuildingDeed: boolToYesNo(basicDetails.isbuilding_deed),
                    buildingDeedRemarks: basicDetails.building_deed_remarks || "",
                    isBuildingPlan: boolToYesNo(basicDetails.isbuilding_plan),
                    buildingPlanRemarks: basicDetails.building_plan_remarks || "",
                    competentAuthorityDesignationRemarks: basicDetails.competent_authority_designation_remarks || "",
                    isApprovedPlanProduced: boolToYesNo(basicDetails.isapproved_plan_produced),
                    approvedPlanProducedRemarks: basicDetails.approved_plan_produced_remarks || "",
                    isBuildingScheduleTally: boolToYesNo(basicDetails.isbuilding_schedule_tally),
                    buildingScheduleTallyRemarks: basicDetails.building_schedule_tally_remarks || "",
                    isBuildingCarpetAreaAsPerNorms: boolToYesNo(basicDetails.isbuilding_carpet_area_as_per_norms),
                    buildingCarpetAreaAsPerNormsRemarks: basicDetails.building_carpet_area_as_per_norms_remarks || "",
                    isConstructionPermissionOrder: boolToYesNo(basicDetails.isconstruction_permission_order),
                    constructionPermissionOrderRemarks: basicDetails.construction_permission_order_remarks || "",
                    isBuildingLocationAsPerNorms: boolToYesNo(basicDetails.isbuilding_location_as_per_norms),
                    buildingLocationAsPerNormsRemarks: basicDetails.building_location_as_per_norms_remarks || "",
                    isBuildingCompletionCertificate: boolToYesNo(basicDetails.isbuilding_completion_certificate),
                    buildingCompletionCertificateRemarks: basicDetails.building_completion_certificate_remarks || "",
                    isSanitaryCertificate: boolToYesNo(basicDetails.issanitary_certificate),
                    sanitaryRemarks: basicDetails.sanitary_remarks || "",
                    isGeotaggedPhotos: boolToYesNo(basicDetails.isgeotagged_photos),
                    geoPhotosRemarks: basicDetails.geo_photos_remarks || "",
                    isOtherInstitutionInSameBuilding: boolToYesNo(basicDetails.isother_institution_in_same_building),
                    otherInstitutionInSameBuildingRemarks: basicDetails.other_institution_in_same_building_remarks || "",
                    isAnnexureOneBuildingDetails: boolToYesNo(basicDetails.isannexure_one_building_details),
                    annexureOneBuildingDetailsRemarks: basicDetails.annexure_one_building_details_remarks || "",
                    isParkingInSamePremises: boolToYesNo(basicDetails.isparking_in_same_premises),
                    parkingInSamePremisesRemarks: basicDetails.parking_in_same_premises_remarks || "",
                    isParkingBuiltUpArea: boolToYesNo(basicDetails.isparking_built_up_area),
                    parkingBuiltUpAreaRemarks: basicDetails.parking_built_up_area_remarks || "",
                    isParkingWithinHundredMeters: boolToYesNo(basicDetails.isparking_within_hundred_meters),
                    parkingWithinHundredMetersRemarks: basicDetails.parking_within_hundred_meters_remarks || "",
                    isPlaygroundInSamePremises: boolToYesNo(basicDetails.isplayground_in_same_premises),
                    playgroundInSamePremisesRemarks: basicDetails.playground_in_same_premises_remarks || "",
                    playgroundExtent: basicDetails.playground_extent || "",
                    playgroundExtentRemarks: basicDetails.playground_extent_remarks || "",
                    isAlternativePlaygroundArrangement: boolToYesNo(basicDetails.isalternative_playground_arrangement),
                    alternativePlaygroundArrangementRemarks: basicDetails.alternative_playground_arrangement_remarks || "",
                    isPlaygroundMouProduced: boolToYesNo(basicDetails.isplayground_mou_produced),
                    playgroundMouProducedRemarks: basicDetails.playground_mou_produced_remarks || "",
                    isLatestFireSafetyCertificate: boolToYesNo(basicDetails.islatest_fire_safety_certificate),
                    latestFireSafetyCertificateRemarks: basicDetails.latest_fire_safety_certificate_remarks || "",
                    financialResourceAmountRequired: basicDetails.financial_resource_amount_required || "",
                    isFinancialResourcesSufficient: boolToYesNo(basicDetails.isfinancial_resources_sufficient),
                    financialResourcesSufficientRemarks: basicDetails.financial_resources_sufficient_remarks || "",
                    financialResourceDeficit: basicDetails.financial_resource_deficit || "",
                    isFinancialResourcePurposeMentioned: boolToYesNo(basicDetails.isfinancial_resource_purpose_mentioned),
                    financialResourcePurposeMentionedRemarks: basicDetails.financial_resource_purpose_mentioned_remarks || "",
                    newProgrammeApprovalFee: basicDetails.new_programme_approval_fee || "",
                    isDetailedProjectReportUploaded: boolToYesNo(basicDetails.isdetailed_project_report_uploaded),
                    detailedProjectReportUploadedRemarks: basicDetails.detailed_project_report_uploaded_remarks || "",
                    isDevelopmentPlanUploaded: boolToYesNo(basicDetails.isdevelopment_plan_uploaded),
                    developmentPlanUploadedRemarks: basicDetails.development_plan_uploaded_remarks || "",
                    isArchitecturalMasterPlanUploaded: boolToYesNo(basicDetails.isarchitectural_master_plan_uploaded),
                    architecturalMasterPlanUploadedRemarks: basicDetails.architectural_master_plan_uploaded_remarks || "",
                    isAcademicAdministrativeGovernanceUploaded: boolToYesNo(basicDetails.isacademic_administrative_governance_uploaded),
                    academicAdministrativeGovernanceUploadedRemarks: basicDetails.academic_administrative_governance_uploaded_remarks || "",
                    isSourcesOfFinancingUploaded: boolToYesNo(basicDetails.issources_of_financing_uploaded),
                    sourcesOfFinancingUploadedRemarks: basicDetails.sources_of_financing_uploaded_remarks || "",
                    isFacultyPoliciesUploaded: boolToYesNo(basicDetails.isfaculty_policies_uploaded),
                    facultyPoliciesUploadedRemarks: basicDetails.faculty_policies_uploaded_remarks || "",
                    finalRemarks: basicDetails.final_remarks || "",
                    finalStatus: basicDetails.final_status || "",
                    deficiencies: scrutinyFinalStatus.length > 0
                        ? scrutinyFinalStatus.map(item => ({ remarks: item.final_status || "" }))
                        : [{ remarks: "" }],
                };

                // Set all form values at once
                formik.setValues(mappedValues);
                setSelectedFinalStatus(basicDetails.final_status || "");

            } catch (error) {
                console.error("Failed to fetch scrutiny data", error);
                failureAlert("Failed to load scrutiny report data");
            }
        };

        fetchScrutinyData();
    }, [defaultCollegeId]);
    console.log("API Values", apiValues);
    const societyDetails = [
        { label: "Society Name", value: getDisplayValue(apiValues.society_name) },
        { label: "Door No", value: getDisplayValue(apiValues.society_door_no) },
        { label: "Street", value: getDisplayValue(apiValues.society_street) },
        { label: "Mandal", value: getDisplayValue(apiValues.society_mandal) },
        { label: "District", value: getDisplayValue(apiValues.society_district) },
        { label: "Mobile", value: getDisplayValue(apiValues.society_mobile) }
    ];

    const collegeDetails = [
        { label: "Proposed College Name", value: getDisplayValue(apiValues.proposed_college_name) },
        { label: "Survey No", value: getDisplayValue(apiValues.college_survey_no) },
        { label: "Door No", value: getDisplayValue(apiValues.college_door_no) },
        { label: "Street", value: getDisplayValue(apiValues.college_street) },
        { label: "Mandal", value: getDisplayValue(apiValues.college_address_mandal) },
        { label: "District", value: getDisplayValue(apiValues.college_address_district) },
        { label: "Mobile", value: getDisplayValue(apiValues.college_mobile) },
        { label: "Email", value: getDisplayValue(apiValues.college_email) }
    ];





    return (

        <div className="faculty-form-wrapper">
            <div className="faculty-card">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <h5 className="text-success mb-3">
                            Scrutiny Report for Starting of New Private Unaided Degree Colleges
                            for The Academic Year 2026-27
                        </h5>

                        <Row className="mb-4">
                            <Col md={6}>
                                <div className="border rounded p-3 bg-light">
                                    <h6 className="text-success mb-3">Name of the Society and Address</h6>
                                    {societyDetails.map((detail) => (
                                        <div key={detail.label} className="mb-2">
                                            <strong>{detail.label}:</strong> {detail.value}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="border rounded p-3 bg-light">
                                    <h6 className="text-success mb-3">Name and address of the Proposed Degree College</h6>
                                    {collegeDetails.map((detail) => (
                                        <div key={detail.label} className="mb-2">
                                            <strong>{detail.label}:</strong> {detail.value}
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Table bordered responsive className="scrutiny-report-table" style={scrutinyTableStyle}>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "8%" }}>S.No</th>
                                            <th style={{ width: "52%" }}>Particulars to be verified based on the documents enclosed to the application</th>
                                            <th style={yesNoHeaderStyle}>Yes / No</th>
                                            <th style={remarksHeaderStyle}>Remarks of the Scrutiny Committee</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                1. Registration and processing fee
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">1.1</td>
                                            <td>
                                                Whether the Registration and processing fee paid (Rs 50,000.)
                                                (please see counter foil of the receipt of the bank)
                                            </td>
                                            <td>
                                                <input type="radio" name="isFeePaid" value="Yes" checked={formik.values.isFeePaid === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes &nbsp;
                                                <input type="radio" name="isFeePaid" value="No" checked={formik.values.isFeePaid === "No"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isFeePaid" />
                                                </div>
                                            </td>
                                            <td>
                                                <input type="text" name="regFeeRemarks" className="form-control" value={formik.values.regFeeRemarks} onChange={formik.handleChange} />
                                            </td>
                                        </tr>

                                        {/* 1.2 Society */}
                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                1.2 Sponsoring Society Details
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">a</td>
                                            <td>Whether the Society is registered under societies registration act</td>
                                            <td>
                                                <input type="radio" name="isSocietyRegistered" value="Yes" checked={formik.values.isSocietyRegistered === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isSocietyRegistered" value="No" checked={formik.values.isSocietyRegistered === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isSocietyRegistered" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="societyRegisteredRemarks" className="form-control" value={formik.values.societyRegisteredRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">b</td>
                                            <td>Whether the Bye-laws of the Society is enclosed</td>
                                            <td>
                                                <input type="radio" name="isByeLawsEnclosed" value="Yes" checked={formik.values.isByeLawsEnclosed === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isByeLawsEnclosed" value="No" checked={formik.values.isByeLawsEnclosed === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isByeLawsEnclosed" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="byeLawsRemarks" className="form-control" value={formik.values.byeLawsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">c</td>
                                            <td>The college is located in</td>
                                            <td>
                                                <select name="locationType" className="form-select" value={formik.values.locationType} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                                                    <option value="">Select</option>
                                                    <option value="Urban">Urban</option>
                                                    <option value="Rural">Rural</option>
                                                    <option value="Tribal">Tribal</option>
                                                </select>
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="locationType" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="locationRemarks" className="form-control" value={formik.values.locationRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">d</td>
                                            <td>Whether the Proposed college is in the list of identified location / Mandal</td>
                                            <td>
                                                <input type="radio" name="isIdentifiedLocation" value="Yes" checked={formik.values.isIdentifiedLocation === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isIdentifiedLocation" value="No" checked={formik.values.isIdentifiedLocation === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isIdentifiedLocation" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="identifiedLocationRemarks" className="form-control" value={formik.values.identifiedLocationRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">e</td>
                                            <td>Whether any other Educational Institution is run by the applicant Society</td>
                                            <td>
                                                <input type="radio" name="isOtherEducationalInstitution" value="Yes" checked={formik.values.isOtherEducationalInstitution === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isOtherEducationalInstitution" value="No" checked={formik.values.isOtherEducationalInstitution === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isOtherEducationalInstitution" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="otherInstitutionRemarks" className="form-control" value={formik.values.otherInstitutionRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">f</td>
                                            <td>If yes, any such existing Degree College is being run in temporary premises /building on lease/rent beyond 10 years</td>
                                            <td>
                                                <input type="radio" name="isTemporaryPremisesBeyondTenYears" value="Yes" checked={formik.values.isTemporaryPremisesBeyondTenYears === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isTemporaryPremisesBeyondTenYears" value="No" checked={formik.values.isTemporaryPremisesBeyondTenYears === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isTemporaryPremisesBeyondTenYears" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="temporaryPremisesBeyondTenYearsRemarks" className="form-control" value={formik.values.temporaryPremisesBeyondTenYearsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">g</td>
                                            <td>Whether any member of the Society/ College has been convicted for any criminal offence or has held a record of criminal behavior</td>
                                            <td>
                                                <input type="radio" name="isCriminalBehavior" value="Yes" checked={formik.values.isCriminalBehavior === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isCriminalBehavior" value="No" checked={formik.values.isCriminalBehavior === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isCriminalBehavior" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="criminalBehaviorRemarks" className="form-control" value={formik.values.criminalBehaviorRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">h</td>
                                            <td>Whether the Society is already managing/ sponsoring a degree college which is not recognized under University Grants Commission 2(f)/12(B)</td>
                                            <td>
                                                <input type="radio" name="isUgcRecognition" value="Yes" checked={formik.values.isUgcRecognition === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isUgcRecognition" value="No" checked={formik.values.isUgcRecognition === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isUgcRecognition" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="ugcRecognitionRemarks" className="form-control" value={formik.values.ugcRecognitionRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">i</td>
                                            <td>Whether the Society have any dues/ complaints pertaining to the Society or its institutions pending with the Competent Authority and/or affiliating University</td>
                                            <td>
                                                <input type="radio" name="isPendingDuesOrComplaints" value="Yes" checked={formik.values.isPendingDuesOrComplaints === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isPendingDuesOrComplaints" value="No" checked={formik.values.isPendingDuesOrComplaints === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isPendingDuesOrComplaints" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="pendingDuesOrComplaintsRemarks" className="form-control" value={formik.values.pendingDuesOrComplaintsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">j</td>
                                            <td>Whether the society is eligible to apply for new college as per norms</td>
                                            <td>
                                                <input type="radio" name="isEligibleForNewCollege" value="Yes" checked={formik.values.isEligibleForNewCollege === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isEligibleForNewCollege" value="No" checked={formik.values.isEligibleForNewCollege === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isEligibleForNewCollege" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="eligibleForNewCollegeRemarks" className="form-control" value={formik.values.eligibleForNewCollegeRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        {/* 2 Land */}
                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                2. Details of the Own Land
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.1</td>
                                            <td>Whether the society has own land as per norms (w.r.t. extent, contiguity, no. of bits and distance between them)</td>
                                            <td>
                                                <input type="radio" name="isOwnLand" value="Yes" checked={formik.values.isOwnLand === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isOwnLand" value="No" checked={formik.values.isOwnLand === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isOwnLand" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="ownLandRemarks" className="form-control" value={formik.values.ownLandRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.2</td>
                                            <td>Whether the registered ownership of the land deed is produced</td>
                                            <td>
                                                <input type="radio" name="isLandDeed" value="Yes" checked={formik.values.isLandDeed === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLandDeed" value="No" checked={formik.values.isLandDeed === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLandDeed" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="landDeedRemarks" className="form-control" value={formik.values.landDeedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.3</td>
                                            <td>Whether the registered document of the land owned in the name of the Society</td>
                                            <td>
                                                <input type="radio" name="isLandInSocietyName" value="Yes" checked={formik.values.isLandInSocietyName === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLandInSocietyName" value="No" checked={formik.values.isLandInSocietyName === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLandInSocietyName" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="landInSocietyNameRemarks" className="form-control" value={formik.values.landInSocietyNameRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.4</td>
                                            <td>Whether the own land is provided in the same Mandal</td>
                                            <td>
                                                <input type="radio" name="isLandInSameMandal" value="Yes" checked={formik.values.isLandInSameMandal === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLandInSameMandal" value="No" checked={formik.values.isLandInSameMandal === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLandInSameMandal" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="landInSameMandalRemarks" className="form-control" value={formik.values.landInSameMandalRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.5</td>
                                            <td>Whether the sketch plan of own land drawn by the licensed surveyor and attested by the MRO is produced</td>
                                            <td>
                                                <input type="radio" name="isLandSketchPlan" value="Yes" checked={formik.values.isLandSketchPlan === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLandSketchPlan" value="No" checked={formik.values.isLandSketchPlan === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLandSketchPlan" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="landSketchPlanRemarks" className="form-control" value={formik.values.landSketchPlanRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">2.6</td>
                                            <td>Whether the schedule of property mentioned in the registered ownership deed is tallying with the sketch plan produced</td>
                                            <td>
                                                <input type="radio" name="isLandScheduleTally" value="Yes" checked={formik.values.isLandScheduleTally === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLandScheduleTally" value="No" checked={formik.values.isLandScheduleTally === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLandScheduleTally" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="landScheduleTallyRemarks" className="form-control" value={formik.values.landScheduleTallyRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        {/* 3 Building */}
                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                3. Building Accommodation
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.1</td>
                                            <td>Whether registered deed of the building is in the name of the college / society is produced</td>
                                            <td>
                                                <input type="radio" name="isBuildingDeed" value="Yes" checked={formik.values.isBuildingDeed === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingDeed" value="No" checked={formik.values.isBuildingDeed === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingDeed" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingDeedRemarks" className="form-control" value={formik.values.buildingDeedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.2</td>
                                            <td>Whether the plan of the building accommodation is approved for running the institution by competent authority</td>
                                            <td>
                                                <input type="radio" name="isBuildingPlan" value="Yes" checked={formik.values.isBuildingPlan === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingPlan" value="No" checked={formik.values.isBuildingPlan === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingPlan" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingPlanRemarks" className="form-control" value={formik.values.buildingPlanRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.2(a)</td>
                                            <td>If "Yes" Mention the Designation of the Competent Authority</td>
                                            <td></td>
                                            <td><input type="text" name="competentAuthorityDesignationRemarks" className="form-control" value={formik.values.competentAuthorityDesignationRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.3</td>
                                            <td>Whether the approved plan of the building drawn by licensed surveyor and attested by the Principal of a Government College is produced</td>
                                            <td>
                                                <input type="radio" name="isApprovedPlanProduced" value="Yes" checked={formik.values.isApprovedPlanProduced === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isApprovedPlanProduced" value="No" checked={formik.values.isApprovedPlanProduced === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isApprovedPlanProduced" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="approvedPlanProducedRemarks" className="form-control" value={formik.values.approvedPlanProducedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.4</td>
                                            <td>Whether the schedule of property mentioned in the registered building document is tallying with the approved building plan</td>
                                            <td>
                                                <input type="radio" name="isBuildingScheduleTally" value="Yes" checked={formik.values.isBuildingScheduleTally === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingScheduleTally" value="No" checked={formik.values.isBuildingScheduleTally === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingScheduleTally" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingScheduleTallyRemarks" className="form-control" value={formik.values.buildingScheduleTallyRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.5</td>
                                            <td>Whether the total carpet area of the building (in sft) is as per norms</td>
                                            <td>
                                                <input type="radio" name="isBuildingCarpetAreaAsPerNorms" value="Yes" checked={formik.values.isBuildingCarpetAreaAsPerNorms === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingCarpetAreaAsPerNorms" value="No" checked={formik.values.isBuildingCarpetAreaAsPerNorms === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingCarpetAreaAsPerNorms" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingCarpetAreaAsPerNormsRemarks" className="form-control" value={formik.values.buildingCarpetAreaAsPerNormsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.6</td>
                                            <td>Whether a copy of the construction permission order for the leased building issued by competent authority is produced</td>
                                            <td>
                                                <input type="radio" name="isConstructionPermissionOrder" value="Yes" checked={formik.values.isConstructionPermissionOrder === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isConstructionPermissionOrder" value="No" checked={formik.values.isConstructionPermissionOrder === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isConstructionPermissionOrder" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="constructionPermissionOrderRemarks" className="form-control" value={formik.values.constructionPermissionOrderRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.7</td>
                                            <td>Whether the location of the building is in accordance with the norms as per the information given in the application (w.r.t. radius of 500 mts., from cinema halls, wines shops, public function halls, whether in flats / sheds/ abandoned go-downs / commercial complexes /thatched houses. etc.,)</td>
                                            <td>
                                                <input type="radio" name="isBuildingLocationAsPerNorms" value="Yes" checked={formik.values.isBuildingLocationAsPerNorms === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingLocationAsPerNorms" value="No" checked={formik.values.isBuildingLocationAsPerNorms === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingLocationAsPerNorms" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingLocationAsPerNormsRemarks" className="form-control" value={formik.values.buildingLocationAsPerNormsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.8</td>
                                            <td>Whether the Building Completion Certificate / Occupancy Certificate is uploaded</td>
                                            <td>
                                                <input type="radio" name="isBuildingCompletionCertificate" value="Yes" checked={formik.values.isBuildingCompletionCertificate === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isBuildingCompletionCertificate" value="No" checked={formik.values.isBuildingCompletionCertificate === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isBuildingCompletionCertificate" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="buildingCompletionCertificateRemarks" className="form-control" value={formik.values.buildingCompletionCertificateRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.9</td>
                                            <td>Whether a copy of valid sanitary certificate is produced</td>
                                            <td>
                                                <input type="radio" name="isSanitaryCertificate" value="Yes" checked={formik.values.isSanitaryCertificate === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isSanitaryCertificate" value="No" checked={formik.values.isSanitaryCertificate === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isSanitaryCertificate" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="sanitaryRemarks" className="form-control" value={formik.values.sanitaryRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.10</td>
                                            <td>Whether Geotagged photographs of the building</td>
                                            <td>
                                                <input type="radio" name="isGeotaggedPhotos" value="Yes" checked={formik.values.isGeotaggedPhotos === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isGeotaggedPhotos" value="No" checked={formik.values.isGeotaggedPhotos === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isGeotaggedPhotos" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="geoPhotosRemarks" className="form-control" value={formik.values.geoPhotosRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.11</td>
                                            <td>Whether any other Institution is running in the same building accommodation</td>
                                            <td>
                                                <input type="radio" name="isOtherInstitutionInSameBuilding" value="Yes" checked={formik.values.isOtherInstitutionInSameBuilding === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isOtherInstitutionInSameBuilding" value="No" checked={formik.values.isOtherInstitutionInSameBuilding === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isOtherInstitutionInSameBuilding" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="otherInstitutionInSameBuildingRemarks" className="form-control" value={formik.values.otherInstitutionInSameBuildingRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.12</td>
                                            <td>Whether the details of existing building accommodation provided in Annexure-I are in accordance with the stipulated norms</td>
                                            <td>
                                                <input type="radio" name="isAnnexureOneBuildingDetails" value="Yes" checked={formik.values.isAnnexureOneBuildingDetails === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isAnnexureOneBuildingDetails" value="No" checked={formik.values.isAnnexureOneBuildingDetails === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isAnnexureOneBuildingDetails" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="annexureOneBuildingDetailsRemarks" className="form-control" value={formik.values.annexureOneBuildingDetailsRemarks} onChange={formik.handleChange} /></td>
                                        </tr>




                                    </tbody>
                                </Table>

                                {/* <h5 className="text-success mb-3">
                            3.13 Accommodation required & provided for Proposed Programmes
                        </h5> */}

                                {/* <Table bordered responsive className="proposed-programmes-table">
                            <thead className="table-primary text-center">
                                <tr>
                                    <th style={{ width: "5%" }}>Sl. No.</th>
                                    <th style={{ width: "20%" }}>Type of the room</th>
                                    <th style={{ width: "10%" }}>No. of room(s) required</th>
                                    <th style={{ width: "10%" }}>Total carpet area (sft) required</th>
                                    <th style={{ width: "10%" }}>No. of room(s) provided</th>
                                    <th style={{ width: "10%" }}>Total carpet area (sft) provided</th>
                                    <th style={{ width: "15%" }}>Whether sufficient as per norms</th>
                                    <th style={{ width: "20%" }}>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">1.</td>
                                    <td>Class room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient1" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks1" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">2.</td>
                                    <td>Laboratory</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient2" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks2" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">3.</td>
                                    <td>Library</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient3" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks3" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">4.</td>
                                    <td>Principal room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient4" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks4" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">5.</td>
                                    <td>Office room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient5" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks5" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">6.</td>
                                    <td>Staff room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient6" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks6" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">7.</td>
                                    <td>Ladies room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient7" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks7" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">8.</td>
                                    <td>Games room</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient8" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks8" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">9.</td>
                                    <td>Toilets</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient9" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks9" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center">10.</td>
                                    <td>Others</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficient10" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarks10" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                                <tr>
                                    <td className="text-center"></td>
                                    <td><strong>Grand total</strong></td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                    <td><input type="text" name="accommodationSufficientGrandTotal" className="form-control" onChange={formik.handleChange} /></td>
                                    <td><input type="text" name="accommodationRemarksGrandTotal" className="form-control" onChange={formik.handleChange} /></td>
                                </tr>
                            </tbody>
                        </Table> */}

                                <Table bordered responsive className="scrutiny-report-table" style={scrutinyTableStyle}>

                                    <tbody>
                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                3.13 Parking area
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>Whether the parking area is available in the same premises</td>
                                            <td>
                                                <input type="radio" name="isParkingInSamePremises" value="Yes" checked={formik.values.isParkingInSamePremises === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isParkingInSamePremises" value="No" checked={formik.values.isParkingInSamePremises === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isParkingInSamePremises" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="parkingSamePremisesRemarks" className="form-control" onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">b.</td>
                                            <td>Whether 20% of the total built up area is provided for the Parking area</td>
                                            <td>
                                                <input type="radio" name="isParkingBuiltUpArea" value="Yes" checked={formik.values.isParkingBuiltUpArea === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isParkingBuiltUpArea" value="No" checked={formik.values.isParkingBuiltUpArea === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isParkingBuiltUpArea" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="parkingBuiltUpAreaRemarks" className="form-control" value={formik.values.parkingBuiltUpAreaRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">c.</td>
                                            <td>If not in the same premises, whether the parking area provided within a distance of 100 meters thereof</td>
                                            <td>
                                                <input type="radio" name="isParkingWithinHundredMeters" value="Yes" checked={formik.values.isParkingWithinHundredMeters === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isParkingWithinHundredMeters" value="No" checked={formik.values.isParkingWithinHundredMeters === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isParkingWithinHundredMeters" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="parkingWithinHundredMetersRemarks" className="form-control" value={formik.values.parkingWithinHundredMetersRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                                3.14 Playground
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>Whether the Playground facility is available in the same premises</td>
                                            <td>
                                                <input type="radio" name="isPlaygroundInSamePremises" value="Yes" checked={formik.values.isPlaygroundInSamePremises === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isPlaygroundInSamePremises" value="No" checked={formik.values.isPlaygroundInSamePremises === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isPlaygroundInSamePremises" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="playgroundSamePremisesRemarks" className="form-control" value={formik.values.playgroundInSamePremisesRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">b.</td>
                                            <td>If yes, mention the extent of the playground facility available (sft)</td>
                                            <td>&nbsp;</td>
                                            <td><input type="text" name="playgroundExtentRemarks" className="form-control" value={formik.values.playgroundExtentRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">c.</td>
                                            <td>If not, whether any alternative arrangement for playground is provided within a radius of 5 kms along with bus facility</td>
                                            <td>
                                                <input type="radio" name="isAlternativePlaygroundArrangement" value="Yes" checked={formik.values.isAlternativePlaygroundArrangement === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isAlternativePlaygroundArrangement" value="No" checked={formik.values.isAlternativePlaygroundArrangement === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isAlternativePlaygroundArrangement" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="alternativePlaygroundArrangementRemarks" className="form-control" value={formik.values.alternativePlaygroundArrangementRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">d.</td>
                                            <td>If yes, whether MoU for utilization of the alternative facility for playground is produced</td>
                                            <td>
                                                <input type="radio" name="isPlaygroundMouProduced" value="Yes" checked={formik.values.isPlaygroundMouProduced === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isPlaygroundMouProduced" value="No" checked={formik.values.isPlaygroundMouProduced === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isPlaygroundMouProduced" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="playgroundMouProducedRemarks" className="form-control" value={formik.values.playgroundMouProducedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">3.16</td>
                                            <td>Whether valid fire safety certificate / latest affidavit for exempted cases is produced</td>
                                            <td>
                                                <input type="radio" name="isLatestFireSafetyCertificate" value="Yes" checked={formik.values.isLatestFireSafetyCertificate === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isLatestFireSafetyCertificate" value="No" checked={formik.values.isLatestFireSafetyCertificate === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isLatestFireSafetyCertificate" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="latestFireSafetyCertificateRemarks" className="form-control" value={formik.values.latestFireSafetyCertificateRemarks} onChange={formik.handleChange} /></td>
                                        </tr>
                                    </tbody>
                                </Table>

                                {showUgProgramsSection && (
                                    <>
                                        <h5 className="text-success mb-3">
                                            4. Details of the Proposed UG programmes
                                        </h5>

                                        <Table bordered responsive className="proposed-ug-programmes-table">
                                            <thead className="table-primary text-center">
                                                <tr>
                                                    <th>Sl No.</th>
                                                    <th>Type of the UG Programme</th>
                                                    <th>Total No. of programmes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getUgCourses.map((program, index) => (
                                                    <tr key={program.id || index}>
                                                        <td className="text-center">{index + 1}.</td>
                                                        <td>
                                                            {getDisplayValue(program.program_name)}
                                                            {program.medium ? ` (${program.medium})` : ""}
                                                        </td>
                                                        <td className="text-center">1</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </>
                                )}

                                <h5 className="text-success mb-3">
                                    5. Financial Resource
                                </h5>

                                <Table bordered responsive className="scrutiny-report-table" style={scrutinyTableStyle}>

                                    <tbody>


                                        <tr>
                                            <td className="text-center">5.1</td>
                                            <td>Total Financial Resource Amount required for starting the programmes</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span>Rs.</span>
                                                    <input type="text" name="financialResourceAmountRequired" className="form-control" inputMode="numeric" value={formik.values.financialResourceAmountRequired} onChange={handleNumericChange} onBlur={formik.handleBlur} />
                                                </div>
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="financialResourceAmountRequired" />
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">5.2</td>
                                            <td>Whether the FDRs towards Financial Resources provided by the society is sufficient for sanctioning the programmes</td>
                                            <td>
                                                <input type="radio" name="isFinancialResourcesSufficient" value="Yes" checked={formik.values.isFinancialResourcesSufficient === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isFinancialResourcesSufficient" value="No" checked={formik.values.isFinancialResourcesSufficient === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isFinancialResourcesSufficient" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="financialResourcesSufficientRemarks" className="form-control" value={formik.values.financialResourcesSufficientRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">a.</td>
                                            <td>If "Not" total amount deficit</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span>Rs.</span>
                                                    <input type="text" name="financialResourceDeficit" className="form-control" inputMode="numeric" value={formik.values.financialResourceDeficit} onChange={handleNumericChange} onBlur={formik.handleBlur} />
                                                </div>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">5.3</td>
                                            <td>Whether purpose "Towards Financial Resources to start a New Private Unaided Degree College" mentioned on the FDR enclosed</td>
                                            <td>
                                                <input type="radio" name="isFinancialResourcePurposeMentioned" value="Yes" checked={formik.values.isFinancialResourcePurposeMentioned === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isFinancialResourcePurposeMentioned" value="No" checked={formik.values.isFinancialResourcePurposeMentioned === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isFinancialResourcePurposeMentioned" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="financialResourcePurposeMentionedRemarks" className="form-control" value={formik.values.financialResourcePurposeMentionedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>
                                    </tbody>
                                </Table>

                                {showCorpusFundSection && (
                                    <>
                                        <h5 className="text-success mb-3">
                                            6. Corpus Fund for Proposed College / UG Programmes
                                        </h5>

                                        <Table bordered responsive className="corpus-fund-table">
                                            <thead className="table-primary text-center">
                                                <tr>
                                                    <th>Sl. No.</th>
                                                    <th>Programme</th>
                                                    <th>Amount</th>
                                                    <th>Period<br />(from - to)</th>
                                                    <th>FDR No.</th>
                                                    <th>Date</th>
                                                    <th>Name &amp; address of the Issuing Bank</th>
                                                    <th>IFSC code</th>
                                                    <th>Date of maturity</th>
                                                    <th>Date of renewal</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {corpusFundInstall.map((fund, index) => (
                                                    <tr key={fund.id || index}>
                                                        <td className="text-center">{index + 1}.</td>
                                                        <td>{getDisplayValue(fund.programme)}</td>
                                                        <td>{getDisplayValue(fund.amount)}</td>
                                                        <td>{`${formatDate(fund.period_from)} - ${formatDate(fund.period_to)}`}</td>
                                                        <td>{getDisplayValue(fund.fdr_no)}</td>
                                                        <td>{formatDate(fund.date)}</td>
                                                        <td>{getDisplayValue(fund.bank_name)}</td>
                                                        <td>{getDisplayValue(fund.ifsc_code)}</td>
                                                        <td>{formatDate(fund.maturity_date)}</td>
                                                        <td>{formatDate(fund.renewal_date)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </>
                                )}



                                <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">

                                    <h5 className="text-success mb-3">
                                        7. NEW Programme Approval Fee:
                                    </h5>


                                    <span className="mb-3 d-flex align-items-center gap-2 flex-wrap">Rs.</span>
                                    <input id="newProgrammeApprovalFee" type="text" name="newProgrammeApprovalFee" className="form-control w-auto" inputMode="numeric" value={formik.values.newProgrammeApprovalFee} onChange={handleNumericChange} onBlur={formik.handleBlur} />
                                </div>
                                <div className="text-danger small mt-1 mb-3">
                                    <ErrorMessage name="newProgrammeApprovalFee" />
                                </div>

                                <h5 className="text-success mb-3">
                                    8. DPR and Other relevant documents
                                </h5>

                                <Table bordered responsive className="scrutiny-report-table" style={scrutinyTableStyle}>
                                    <tbody>
                                        {/* <tr>
                                    <td colSpan="4" style={{ fontWeight: "bold", background: "#f1f1f1" }}>
                                        8. DPR and Other relevant documents
                                    </td>
                                </tr> */}

                                        <tr>
                                            <td className="text-center">8.1</td>
                                            <td>Whether the Detailed Project Report is uploaded</td>
                                            <td>
                                                <input type="radio" name="isDetailedProjectReportUploaded" value="Yes" checked={formik.values.isDetailedProjectReportUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isDetailedProjectReportUploaded" value="No" checked={formik.values.isDetailedProjectReportUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isDetailedProjectReportUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="detailedProjectReportUploadedRemarks" className="form-control" value={formik.values.detailedProjectReportUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">8.2</td>
                                            <td>Whether the Development Plan for the College is uploaded</td>
                                            <td>
                                                <input type="radio" name="isDevelopmentPlanUploaded" value="Yes" checked={formik.values.isDevelopmentPlanUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isDevelopmentPlanUploaded" value="No" checked={formik.values.isDevelopmentPlanUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isDevelopmentPlanUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="developmentPlanUploadedRemarks" className="form-control" value={formik.values.developmentPlanUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">8.3</td>
                                            <td>Whether the Architectural Master Plan is uploaded</td>
                                            <td>
                                                <input type="radio" name="isArchitecturalMasterPlanUploaded" value="Yes" checked={formik.values.isArchitecturalMasterPlanUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isArchitecturalMasterPlanUploaded" value="No" checked={formik.values.isArchitecturalMasterPlanUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isArchitecturalMasterPlanUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="architecturalMasterPlanUploadedRemarks" className="form-control" value={formik.values.architecturalMasterPlanUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">8.4</td>
                                            <td>Whether the Structure of Academic Administrative Governance of the college is uploaded</td>
                                            <td>
                                                <input type="radio" name="isAcademicAdministrativeGovernanceUploaded" value="Yes" checked={formik.values.isAcademicAdministrativeGovernanceUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isAcademicAdministrativeGovernanceUploaded" value="No" checked={formik.values.isAcademicAdministrativeGovernanceUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isAcademicAdministrativeGovernanceUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="academicAdministrativeGovernanceUploadedRemarks" className="form-control" value={formik.values.academicAdministrativeGovernanceUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">8.5</td>
                                            <td>Whether the sources of financing of capital and operating expenditure is uploaded</td>
                                            <td>
                                                <input type="radio" name="isSourcesOfFinancingUploaded" value="Yes" checked={formik.values.isSourcesOfFinancingUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isSourcesOfFinancingUploaded" value="No" checked={formik.values.isSourcesOfFinancingUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isSourcesOfFinancingUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="sourcesOfFinancingUploadedRemarks" className="form-control" value={formik.values.sourcesOfFinancingUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>

                                        <tr>
                                            <td className="text-center">8.6</td>
                                            <td>Whether the Policies with regard to faculty recruitment, retention, development, etc., are uploaded</td>
                                            <td>
                                                <input type="radio" name="isFacultyPoliciesUploaded" value="Yes" checked={formik.values.isFacultyPoliciesUploaded === "Yes"} onChange={formik.handleChange} onBlur={formik.handleBlur} /> Yes
                                                <input type="radio" name="isFacultyPoliciesUploaded" value="No" checked={formik.values.isFacultyPoliciesUploaded === "No"} className="ms-2" onChange={formik.handleChange} onBlur={formik.handleBlur} /> No
                                                <div className="text-danger small mt-1">
                                                    <ErrorMessage name="isFacultyPoliciesUploaded" />
                                                </div>
                                            </td>
                                            <td><input type="text" name="facultyPoliciesUploadedRemarks" className="form-control" value={formik.values.facultyPoliciesUploadedRemarks} onChange={formik.handleChange} /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        <Row className="mt-5">
                            <Col md={12}>
                                <h5 className="text-success mb-3">Final Remarks</h5>
                                <div className="mb-3">
                                    <textarea
                                        name="finalRemarks"
                                        className="form-control"
                                        rows="5"
                                        style={{
                                            height: "auto",
                                            resize: "vertical"
                                        }}
                                        placeholder="Enter final remarks..."
                                        value={formik.values.finalRemarks}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <ErrorMessage name="finalRemarks" component="div" className="text-danger mt-1" />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-3 mb-4">
                            <Col md={3}>
                                <h5 className="text-success mb-3">Final Status</h5>
                                <select
                                    name="finalStatus"
                                    className="form-control"
                                    value={selectedFinalStatus || formik.values.finalStatus}
                                    onChange={handleFinalStatusChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="">-- Select Status --</option>
                                    <option value="DeficiencyIdentified">Deficiencies Found</option>
                                    <option value="NoDeficienciesIdentified">No Deficiencies</option>
                                </select>
                                <ErrorMessage name="finalStatus" component="div" className="text-danger mt-1" />
                            </Col>
                        </Row>

                        {/* {showDeficienciesSection && (
                            <Row className="mt-4">
                                <Col>
                                    <h5 className="text-success mb-3">Deficiencies Found</h5>
                                    <Table bordered responsive className="deficiency-table">
                                        <thead className="table-primary text-center">
                                            <tr>
                                                <th style={{ width: "8%" }}>S.No</th>
                                                <th style={{ width: "75%" }}>Deficiency Identified</th>
                                                <th style={{ width: "17%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deficiencies.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter deficiency details..."
                                                            value={item.deficiency}
                                                            onChange={(e) => updateDeficiency(item.id, e.target.value)}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        {deficiencies.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-link text-danger p-0"
                                                                onClick={() => deleteDeficiencyRow(item.id)}
                                                                title="Delete this row"
                                                            >
                                                                <BiTrash size={20} />
                                                            </button>
                                                        )}
                                                        {index === deficiencies.length - 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-link text-success p-0 ms-2"
                                                                onClick={addDeficiencyRow}
                                                            >
                                                                <VscDiffAdded size={20} />Add
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        )} */}

                        {formik.values.finalStatus === "DeficiencyIdentified" && (
                            <div className="mt-3">
                                <Table bordered responsive>
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th style={{ width: "10%" }}>S.No</th>
                                            <th style={{ width: "70%" }}>Deficiency Identified</th>
                                            <th style={{ width: "20%" }}>Action</th>
                                        </tr>
                                    </thead>

                                    <FieldArray name="deficiencies">
                                        {({ push, remove }) => {
                                            const deficiencies = formik?.values?.deficiencies;

                                            return (
                                                <tbody>
                                                    {deficiencies?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center fw-bold">{index + 1}</td>
                                                            <td>
                                                                <Field
                                                                    as="textarea"
                                                                    name={`deficiencies.${index}.remarks`}
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Enter deficiency details..."
                                                                    rows="2"
                                                                />
                                                                <ErrorMessage
                                                                    name={`deficiencies.${index}.remarks`}
                                                                    component="small"
                                                                    className="text-danger"
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                {deficiencies.length > 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link text-danger p-0"
                                                                        onClick={() => remove(index)}
                                                                    >
                                                                        <BiTrash size={20} />
                                                                    </button>
                                                                )}
                                                                {index === deficiencies.length - 1 && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-link text-success p-0 ms-2"
                                                                        onClick={() => push({ remarks: "" })}
                                                                    >
                                                                        <VscDiffAdded size={20} /> Add
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            );
                                        }}
                                    </FieldArray>
                                </Table>
                            </div>
                        )}
                        {getScrtinyDtlsforclg?.BasicDetails?.[0]?.final_status === "" ?
                            <Row className="mt-4">
                                <Col className="d-flex justify-content-end">
                                    <button type="button" className="btn btn-secondary me-2" onClick={handleSave}>
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={handleSubmitClick}
                                    >
                                        Final Submit
                                    </button>
                                </Col>
                            </Row> : <div className="d-flex justify-content-end mt-3 align-items-center">
                                <span className="text-success me-3">✅ Already Submitted</span>
                            </div>
                        }

                    </Form>
                    <style>{`
                .scrutiny-report-table th:nth-child(3),
                .scrutiny-report-table td:nth-child(3) {
                    padding-left: 2px;
                    padding-right: 2px;
                    text-align: center;
                    vertical-align: middle;
                }
            `}</style>
                </FormikProvider>
            </div>
        </div>
    );
}
